<template>
  <v-dialog
    v-model="dialogFlag"
    max-width="630"
    persistent
  >
    <v-card>
      <v-card-title>
        For Global Leadership and Team Coaches
        <v-spacer />
        <v-btn
          icon
          class="mt-n2 mr-n2"
          @click="dialogFlag = false"
        >
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        In order to gain access to your public Coach Profile with a custom URL,
        <a
          href="https://globalcoachgroup.com/certification-sign-up/"
          target="_blank"
        >
          please first get certified as a Global Leadership and Team Coach.
        </a>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CertifiedNeededModal',

  data: () => ({
    dialogFlag: false,
  }),

  mounted() {
    this.$EventBus.$on('certification-needed', () => {
      this.dialogFlag = true;
    });
  },

  beforeDestroy() {
    this.$EventBus.$off('certification-needed');
  },
};
</script>
